export const SUPPORTS_OBJECT_IS_FROZEN = "isFrozen" in Object;
